import { render, staticRenderFns } from "./OrderPaymentFiltersForm.vue?vue&type=template&id=267ad214&"
import script from "./OrderPaymentFiltersForm.vue?vue&type=script&lang=ts&"
export * from "./OrderPaymentFiltersForm.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports